import axios from 'axios';
import { decrypt } from './function'
import { toast } from 'react-toastify';
import { ApiBaseURL } from '../helper/function'
const AxiosInstance = axios.create({
  baseURL: ApiBaseURL('/api')
});
AxiosInstance.interceptors.request.use((config) => {
  config.headers["X-Auth-Token"] = sessionStorage.getItem("token");
  return config;
}, (error) => {
  return Promise.reject(error)
});
AxiosInstance.interceptors.response.use(async (response) => {
  const responseOnject = await decrypt(response.data);
  return responseOnject
}, (error) => {
  toast.error(error.response.data.Message || error.message, { position: "top-center", autoClose: 700 })
  if (error.status == 401) {
    //window.location.href='/login'
  }
  return Promise.reject(error);
});
export default AxiosInstance